import cx from 'classnames'
import React from 'react'
import { Primary, Tertiary } from '@cinch/oxd-components/button/src'
import Link from '@cinch/oxd-components/link/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import * as styles from './lifestyle-actions.module.css'

interface ActionProps {
  resultLink: string
  currentPage: number
  className?: string
  i18n: {
    next: string
    back: string
    results: string
    privacyNotice: string
  }
  isPending: boolean
  isNextDisabled: boolean
  allowSkip: boolean

  goToPage: (pageNumber: number) => void
}

const Actions: React.FC<ActionProps> = ({
  i18n,
  resultLink,
  currentPage,
  goToPage,
  className,
  isPending,
  isNextDisabled = false,
  allowSkip = false,
}) => {
  const shouldShowBackButton = currentPage > 1

  const [hasMounted, setHasMounted] = React.useState(false)

  React.useEffect(() => {
    setHasMounted(true)
  }, [])

  return (
    <div className={cx(styles.actions, className)}>
      <div className={styles.buttons}>
        <Tertiary
          data-testid="lifestyle-actions__back-btn"
          isLoading={isPending}
          className={cx(styles.button, { [styles.buttonInvisible]: !shouldShowBackButton })}
          type="button"
          onClick={() => goToPage(currentPage - 1)}
        >
          {i18n.back}
        </Tertiary>
        {hasMounted && (
          <Primary
            data-testid="lifestyle-actions__next-btn"
            disabled={isNextDisabled}
            isLoading={isPending}
            oxdClassName={styles.button}
            type="submit"
            oxford={true}
          >
            {i18n.next}
          </Primary>
        )}
      </div>
      <Link to={resultLink} className={cx(styles.link, { [styles.linkInvisible]: !allowSkip })}>
        {i18n.results}
      </Link>
      <Text type={TextStyles.bullet} element="p" className={styles.privacyText}>
        <span dangerouslySetInnerHTML={{ __html: i18n.privacyNotice }} />
      </Text>
    </div>
  )
}

export default Actions
